export const PLANE_SIZE = 10
export const FOG_FAR = 40